<template>
  <div>
    <top></top>
    <div class="bg_wrap">
      <!-- <topPiece></topPiece> -->
      <div class="container" v-loading="loading">
        <!--        <template v-if="!detail_show">-->
        <!--          <titleConfig-->
        <!--              :title="langSet == 'cn' ? '展商名录' : 'Exhibitor List'"-->
        <!--              :type="2"-->
        <!--          ></titleConfig>-->
        <!--          <div class="_search" v-if="label_list.length>0">-->
        <!--            <Select_input_search-->
        <!--                :options="search_options"-->
        <!--                :placeholder_select="placeholder_select"-->
        <!--                :placeholder_input="placeholder_input"-->
        <!--                :select_key="'value'"-->
        <!--                :select_label="langSet == 'cn' ? 'name' : 'name_en'"-->
        <!--                :label_list="label_list"-->
        <!--                @query_change="query_change"-->
        <!--            ></Select_input_search>-->
        <!--            &lt;!&ndash;          name_en&ndash;&gt;-->
        <!--          </div>-->
        <!--          <template>-->
        <!--            <nodata v-if="companyLists.length == 0"></nodata>-->
        <!--            <Company_list-->
        <!--                v-else-->
        <!--                :companyLists="companyLists"-->
        <!--                @item_click="item_click"-->
        <!--            ></Company_list>-->
        <!--          </template>-->
        <!--          <div class="block">-->
        <!--            <el-pagination-->
        <!--                @size-change="sizeChange"-->
        <!--                @current-change="currentChange"-->
        <!--                :page-sizes="[8, 16, 32]"-->
        <!--                :page-size="pageSize"-->
        <!--                layout="prev, pager, next,sizes"-->
        <!--                :total="total"-->
        <!--            >-->
        <!--            </el-pagination>-->
        <!--          </div>-->
        <!--        </template>-->
        <template>
          <titleConfig
            v-if="false"
            :title="langSet == 'cn' ? '展商详情' : 'Exhibitor Details'"
            :type="2"
          ></titleConfig>
          <newTitle
            :title="langSet === 'cn' ? '展商详情' : 'Exhibitor Details'"
          ></newTitle>
          <div class="company_box">
            <div class="company_box_left">
              <div class="_left_image_box">
                <img
                  class="image_left"
                  :src="
                    company_detail.cover ||
                    'https://oss.chinadentalshow.com/uploads/images/20260916/c898e40a15c88641734a992da37ff30c.jpg'
                  "
                  alt=""
                />
              </div>

              <div>
                <div class="company_title">{{ company_detail.title }}</div>
                <div class="company_mobile flex">
                  <div class="company_booth_no">
                    {{ langSet == "cn" ? "展位号：" : "Booth No："
                    }}{{ company_detail.booth_no }}
                  </div>
                  <div class="company_enterprise_type">
                    {{
                      langSet == "cn"
                        ? "展商类别：" + (company_detail.enterprise_type || "")
                        : "Exhibitor Category：" +
                          (company_detail.enterprise_type_en || "")
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mobile_btn flex">
              <div
                :class="[
                  'Collection',
                  company_detail.is_collect == 0 ? '' : 'Collection_change',
                ]"
                @click="collect"
              >
                <div>
                  {{
                    company_detail.is_collect == 0
                      ? langSet == "cn"
                        ? "收藏"
                        : "collect"
                      : langSet == "cn"
                      ? "已收藏"
                      : "Collected"
                  }}
                </div>
                <div>|</div>
                <img class="Collection_image" src="@/assets/aixin.png" alt="" />
              </div>
              <div class="leave" @click="leave_click">
                {{ langSet == "cn" ? "我要留言" : "Leave Message" }}
              </div>
            </div>
            <!--          <div class="see_button">查看详情</div>-->
          </div>
          <div class="company_content">
            <Content_top
              :title="langSet == 'cn' ? '公司简介' : 'Company Profile'"
            ></Content_top>
            <div class="content_text">
              {{
                langSet == "cn"
                  ? company_detail.content
                  : company_detail.en_content
              }}
            </div>
            <Content_top
              :title="langSet == 'cn' ? '联系我们' : 'Contact Us'"
            ></Content_top>
            <div class="content_bottom">
              {{ langSet == "cn" ? "地址：" : "Address："
              }}{{ company_detail.address }}
            </div>
            <div class="content_bottom">
              {{ langSet == "cn" ? "网址：" : "URL："
              }}{{ company_detail.company_url }}
            </div>
          </div>
          <titleConfig
            :title="langSet == 'cn' ? '展商产品' : 'Exhibitors Products'"
            :type="2"
          ></titleConfig>
          <div class="product_box">
            <Product_list
              :productLists="productLists"
              @item_click="go_product_detail"
            ></Product_list>
            <nodata v-if="productLists.length == 0"></nodata>
          </div>
        </template>
      </div>
      <el-dialog
        v-if="dialogVisible"
        :title="
          langSet == 'cn'
            ? '请填写您的需求留言'
            : 'Please fill in your requirement message'
        "
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div>
          <div class="line"></div>
          <div class="dialog_box_top">
            <div class="title_picture">
              <img :src="userInfo.avatar_uri" alt="" />
              <img
                v-if="userInfo.exhibitor_long_id"
                src="@/assets/authentication.png"
                alt=""
              />
            </div>
            <div style="color: #ffffff">
              <div class="title_name">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo.position }}</div>
              </div>
              <div class="company">{{ userInfo.company_name }}</div>
            </div>
            <!--            <img class="edit_img" src="@/assets/edit.png" alt=""/>-->
          </div>
          <el-input
            type="textarea"
            :rows="7"
            :placeholder="
              langSet == 'cn'
                ? '请输入您的需求留言'
                : 'Please enter your requirements and leave a message'
            "
            v-model="leave_content"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <!--    <el-button @click="dialogVisible = false">取 消</el-button>-->
          <el-button class="submit" type="primary" @click="submit">{{
            langSet == "cn" ? "提 交" : "Submit"
          }}</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>


<script>
import top from "@/components/top.vue";
import newTitle from "@/components/new_title.vue";
import titleConfig from "@/components/title.vue";
// import topPiece from "@/components/topPiece.vue";
import {
  categoryLists,
  MemberConsultation_add,
  product_detail,
  product_lists,
} from "@/api/product_api";
import bottom from "@/components/bottom.vue";
// import Select_input_search from "@/components/Select_input_search.vue";
import { company_detail, company_lists } from "@/api/company_api";
import { dict_lists, public_collect } from "@/api/api";
import Product_list from "@/views/product/component/product_list.vue";
import nodata from "@/components/nodata.vue";
// import Company_list from "@/views/company/component/company_list.vue";
import Content_top from "@/components/content_top.vue";
import router from "@/router";

export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  name: "companyDetail",
  components: {
    Content_top,
    // Company_list,
    nodata,
    Product_list,
    bottom,
    newTitle,
    titleConfig,
    top,
    //topPiece,
    // Select_input_search,
  },
  data() {
    return {
      langSet: "cn",
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      flag: localStorage.getItem("Flag") || "",
      label_list: [],
      loading: false,
      pageSize: 8,
      pageNo: 1,
      total: 0,
      companyLists: [],
      label_name: "",
      enterprise_type: "",
      search_options: [],
      placeholder_select: "请选择企业类别",
      placeholder_input: "搜索展商名称或展位号",
      keywords: "",
      keywords_en: "",
      detail_product: {},
      company_detail: {},
      detail_show: false,
      dialogVisible: false,
      leave_content: "",
      productLists: [],
      label_value: "",
      metaData: {},
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    console.log(path, "===path");
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    let query = this.$route.query;
    if (query.detail_show) {
      this.go_to_detail(query);
    } else {
      // this.get_lists();
      // this.get_categoryLists();
      // this.placeholder_select =
      //     this.langSet == "cn"
      //         ? "请选择企业类别"
      //         : "Please select enterprise category";
      // this.placeholder_input =
      //     this.langSet == "cn"
      //         ? "搜索展商名称或展位号"
      //         : "Search for exhibitor name or booth number";
      // this.get_dict_lists();
    }
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async go_to_detail(query) {
      this.loading = true;
      this.detail_show = query.detail_show;
      await this.get_company_detail(query.exhibitor_long_id);
      await this.get_product_lists();
      this.loading = false;
    },
    // 字典
    async get_dict_lists() {
      const res = await dict_lists({ type: "level_tag_type" });
      this.label_list = res.data.level_tag_type;
      this.label_list.unshift({
        id: 999,
        name: "全部展商",
        name_en: "All Exhibitors",
        type_value: "Exhibitors",
        value: "",
      });
    },
    query_change(data) {
      this.enterprise_type = data.select_value;
      this.page_no = data.pageNo;
      this.label_value = data.label_value;
      if (this.langSet == "cn") {
        this.keywords = data.search_input;
        this.keywords_en = "";
      } else {
        this.keywords = "";
        this.keywords_en = data.search_input;
      }
      this.get_lists();
    },
    async get_lists() {
      let data = {
        keywords: this.keywords,
        keywords_en: this.keywords_en,
        enterprise_type: this.enterprise_type,
        page_no: this.pageNo,
        page_size: this.pageSize,
        level_tag: this.label_value,
      };
      const res = await company_lists(data);
      this.companyLists = res.data.lists;
      this.total = res.data.count;
    },
    async get_categoryLists() {
      const res = await dict_lists({ type: "enterprise_type_arr" });
      this.search_options = res.data.enterprise_type_arr;
    },
    async get_product_lists() {
      let data = {
        page_no: 1,
        page_size: 100,
        exhibitor_long_id: this.company_detail.exhibitor_long_id,
      };
      const res = await product_lists(data);
      this.productLists = res.data.lists;
    },
    currentChange(e) {
      this.pageNo = e;
      this.get_lists();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.get_lists();
    },
    async item_click(item) {
      await this.get_company_detail(item.exhibitor_long_id);
      await this.get_product_lists();
      this.details_show_change();
    },
    async get_company_detail(exhibitor_long_id) {
      const company_res = await company_detail({
        exhibitor_long_id: exhibitor_long_id,
      });
      this.company_detail = company_res.data;
    },

    async go_product_detail(item) {
      this.$router.push({
        path: "/product",
        query: {
          detail_show: true,
          product_long_id: item.product_long_id,
          exhibitor_long_id: item.exhibitor_long_id,
        },
      });
    },
    details_show_change() {
      this.detail_show = !this.detail_show;
      window.scrollTo(0, 0);
    },
    leave_click() {
      if (this.flag == "isLogin") {
        this.dialogVisible = true;
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },

    handleClose(done) {
      done();
      // this.$confirm('确认关闭？')
      //     .then(_ => {
      //     })
      //     .catch(_ => {
      //     });
    },
    async collect() {
      if (this.flag == "isLogin") {
        let data = {
          action: this.company_detail.is_collect == 0 ? 1 : 0,
          type: "company",
          dataid: this.company_detail.id,
        };
        const res = await public_collect(data);
        this.$message({ message: res.msg, type: "success" });
        await this.get_company_detail(this.company_detail.exhibitor_long_id);
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    async submit() {
      let data = {
        exhibitor_long_id: this.company_detail.exhibitor_long_id,
        content: this.leave_content,
      };
      const res = await MemberConsultation_add(data);
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.dialogVisible = false;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
};
</script>


<style scoped lang="scss">
._search {
  margin: 40px 0 20px 0;
}

/deep/ .el-pagination {
  text-align: center;
  margin: 50px 0 100px 0;
}

//详情
.company_box {
  //width: 1280px;
  height: 128px;
  background: #004190;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin: 40px 0 30px 0;
}

.company_box_left {
  //width: 60%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

._left_image_box {
  width: 160px;
  height: 90px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
}

.image_left {
  //height: auto;
  object-fit: contain;
  width: 90px;
  height: 90px;
}

.company_title {
  font-weight: 600;
  font-size: 20px;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin-bottom: 10px;
}

.company_booth_no {
  margin-right: 80px;
  color: #ffffff;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

.company_enterprise_type {
  color: #ffffff;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}

.see_button {
  width: 116px;
  height: 40px;
  background: #3d82d6;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  cursor: pointer;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.company_content {
  width: 100%;
  //min-height: 480px;
  margin-bottom: 50px;
  padding: 30px;
  background: #f7f8fa;
  box-sizing: border-box;
}

.content_top {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 20px;
  color: #004190;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}

.ball {
  display: flex;
}

.ball div:nth-child(1) {
  margin-left: 5px;
  width: 12px;
  height: 12px;
  background: #e62344;
  border-radius: 50%;
}

.ball div:nth-child(2) {
  margin-left: -2px;
  width: 12px;
  height: 12px;
  background: #004190;
  border-radius: 50%;
}

.Collection {
  width: 124px;
  height: 40px;
  background: #3d82d6;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 15px;
}

.Collection_change {
  background: #e62344;
}

.Collection_image {
  width: 15px;
  height: 13px;
}

.Collection > div:nth-child(2) {
  margin: 0 10px;
}

.leave {
  width: 124px;
  height: 40px;
  background: #3d82d6;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.margin_bottom20 {
  margin-bottom: 20px;
}

/deep/ .el-dialog__wrapper {
}

/deep/ .el-dialog {
  top: 5%;
  width: 480px !important;
  height: 445px !important;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
}

/deep/ .el-dialog__footer {
  position: absolute;
  display: flex;
  margin: auto;
  left: 0;
  right: 0;
  justify-content: center;
  bottom: 0;
}

/deep/ .el-dialog__body {
  padding: 0 30px !important;
}

.line {
  width: 100%;
  border-bottom: 1px solid #f3f3f3;
}

.dialog_box_top {
  position: relative;
  display: flex;
  padding: 10px;
  align-items: center;
  height: 96px;
  background: #004190;
  border-radius: 8px;
  margin: 20px 0 15px 0;
}

.title_picture {
  position: relative;
  margin-right: 10px;
}

.title_picture > img:first-child {
  width: 65px;
  height: 65px;
  border-radius: 50%;
}

.title_picture > img:nth-child(2) {
  width: 20px;
  height: 20px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.title_name {
  display: flex;
  margin-bottom: 5px;
  align-items: center;
}

.title_name > div:nth-child(1) {
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  line-height: 25px;
  letter-spacing: 1px;
  text-align: center;
  font-style: normal;
}

.title_name > div:nth-child(2) {
  margin-left: 10px;
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 21px;
  text-align: center;
  font-style: normal;
}

.company {
  font-weight: 400;
  font-size: 15px;
  color: #ffffff;
  line-height: 21px;
  text-align: center;
  font-style: normal;
}

.edit_img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}

.submit {
  width: 180px;
  height: 42px;
  border-radius: 9px;
  background-color: #004190;
  border-color: #004190;
}

.submit:hover {
  background-color: #004190;
  opacity: 0.9;
}

.submit:focus {
  background-color: #004190;
  opacity: 1;
}

.content_text {
  font-weight: 400;
  font-size: 18px;
  color: #2c2c2e;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  margin-bottom: 40px;
}

.content_bottom {
  font-weight: 400;
  font-size: 18px;
  color: #2c2c2e;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  margin-bottom: 10px;
}

.product_box {
  margin-bottom: 60px;
}

/* 平板：一行3个 */
@media (max-width: 768px) {
  .flex-item {
    flex-basis: calc(33.33% - 10px);
  }
}

/* 手机：一行2个 */
@media (max-width: 480px) {
  .flex-item {
    flex-basis: calc(50% - 10px);
  }
}

@media only screen and (max-width: 767px) {
  .company_box {
    height: 2.08rem;
    position: relative;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 0.38rem 0.29rem;
    margin: 0.38rem 0 1.54rem;

    ._left_image_box {
      width: 2.31rem;
      height: 1.3rem;
      margin-right: 0.19rem;
    }

    .company_title {
      font-size: 0.29rem;
      line-height: 0.4rem;
      margin-bottom: 0.1rem;
    }

    .company_mobile {
      flex-wrap: wrap;
    }

    .company_booth_no,
    .company_enterprise_type {
      width: 100%;
      font-size: 0.25rem;
      line-height: 0.35rem;
    }

    .mobile_btn {
      width: 100%;
      position: absolute;
      bottom: -1.18rem;
      left: 0;
      justify-content: center;
    }
  }
  .company_content {
    padding: 0.29rem;
    box-sizing: border-box;
  }
  .content_top {
    font-size: 0.31rem;
    line-height: 0.42rem;
    margin-bottom: 0.29rem;
  }
  .content_text {
    font-size: 0.27rem;
    line-height: 0.42rem;
    margin-bottom: 0.38rem;
  }
  .content_bottom {
    font-size: 0.27rem;
    line-height: 0.42rem;
    margin-bottom: 0.1rem;
  }
  /deep/ .el-dialog {
    width: 6.54rem !important;
  }
  /deep/ .el-dialog__body {
    padding: 0 0.29rem !important;
  }
  /deep/ .el-dialog__title {
    font-weight: 500;
    font-size: 0.31rem;
    line-height: 0.42rem;
  }
  .dialog_box_top {
    height: 1.63rem;
    margin: 0.19rem 0 0.4rem;
  }
  .title_name {
    margin-bottom: 0.1rem;

    > div:nth-child(1) {
      font-size: 0.27rem;
      line-height: 0.38rem;
    }
  }
  .company {
    font-size: 0.23rem;
    line-height: 0.33rem;
  }
}
</style>